import { Component, computed, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CampaignConfig } from '../../models/campaign.models';
import { Environment } from '@micro-core/environment';
import { CampaignsService } from '@brightside-web/desktop/feature/campaigns';

@Component({
    selector: 'bw-campaign-promotion-card',
    imports: [CommonModule, BrightsideUiModule, TranslateModule],
    templateUrl: './campaign-promotion-card.component.html',
    styleUrl: './campaign-promotion-card.component.scss'
})
export class CampaignPromotionCardComponent {
  data = signal<unknown | undefined>(undefined);
  cardConfig: ActionCardConfigInterface;

  private _campaignConfig: CampaignConfig;

  private _campaignService = inject(CampaignsService);
  private _translateService: TranslateService = inject(TranslateService);
  private _router: Router = inject(Router);
  private _env: Environment = inject(Environment);

  protected onCtaClicked() {
    this._campaignService.setActiveCampaignFromCard(this._campaignConfig);
  }

  constructor() {
    effect(() => {
      const localcardConfig = this.data() as {data: CampaignConfig};
    
      if (localcardConfig) {
        this._campaignConfig = localcardConfig.data;
        const cardInfo = localcardConfig.data.card
        this.cardConfig = {
          cardStyle: 'large',
          title: this._translateService.instant(cardInfo.title),
          body: this._translateService.instant(cardInfo.desc),
          ctaString: this._translateService.instant(cardInfo.cta1.copyKey),
          image: `${this._env.cdnUrl}images/app/${cardInfo.image}.png`
        }
      }
    }, {allowSignalWrites: true});
  }
}
